export default "__VITE_ASSET__C0J7u6UV__"